import restClient from "../restClient";

export const getMailProfile = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.get(`mail-profiles/${id}?populate=*`, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const updateMailProfile = async ({ id, data }) => {
  try {
    const token = localStorage.getItem('token');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const response = await restClient.put(`mail-profiles/${id}`, { data }, config);
    return response.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
